/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { combinationsDependencies } from './dependenciesCombinations.generated';
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { isNegativeDependencies } from './dependenciesIsNegative.generated';
import { isPositiveDependencies } from './dependenciesIsPositive.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createComposition } from '../../factoriesAny.js';
export var compositionDependencies = {
  addScalarDependencies: addScalarDependencies,
  combinationsDependencies: combinationsDependencies,
  isIntegerDependencies: isIntegerDependencies,
  isNegativeDependencies: isNegativeDependencies,
  isPositiveDependencies: isPositiveDependencies,
  largerDependencies: largerDependencies,
  typedDependencies: typedDependencies,
  createComposition: createComposition
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesComposition.generated.js
// module id = 1508
// module chunks = 0